// extracted by mini-css-extract-plugin
var _1 = "EmailPriorityTag-moduleEmailPriorityTag__bvVxa IconNG-moduleiconContainer__SxWZ0";
export { _1 as "EmailPriorityTag" }
